import { ghostBtnClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function ManufacturingLaborCompanyRateImportLeftoverPrompt({
  count,
  busy,
  canImportRemaining,
  onImportRemaining,
  onDownload,
  onSkip,
}: {
  count: number;
  busy: boolean;
  canImportRemaining: boolean;
  onImportRemaining: () => void;
  onDownload: () => void;
  onSkip: () => void;
}) {
  const noun = count === 1 ? "leftover" : "leftovers";
  return (
    <div className="mt-4 space-y-3">
      <p className="text-sm text-gray-800 dark:text-zinc-200">
        <strong>{count}</strong> {noun} did not merge. Unmatched and rejected rows with a rate are already
        parked as pay items.
        {canImportRemaining
          ? " Import remaining suggested matches as unmatched so you can match them later, or download the leftover CSV."
          : " Download the leftover CSV if you still need rows that had no rate or would overwrite a matched SKU."}
      </p>
      <div className="flex flex-wrap justify-end gap-2">
        <button type="button" className={ghostBtnClass} disabled={busy} onClick={onSkip}>
          Not now
        </button>
        {canImportRemaining ? (
          <button type="button" className={ghostBtnClass} disabled={busy} onClick={onImportRemaining}>
            Import remaining as unmatched
          </button>
        ) : null}
        <button type="button" className={mfgPrimaryBtnClass} disabled={busy} onClick={onDownload}>
          Download leftovers
        </button>
      </div>
    </div>
  );
}
